<template>
  <div class="search-container">
    <el-form ref="form" inline>
      <el-form-item label="门店名称" label-width="80px">
        <el-input v-model="queryParam.companyName" clearable></el-input>
      </el-form-item>
      <el-form-item label="姓名" label-width="80px">
        <el-input v-model="queryParam.name" clearable></el-input>
      </el-form-item>
      <el-form-item label="手机号" label-width="80px">
        <el-input v-model="queryParam.phone" clearable></el-input>
      </el-form-item>
      <el-form-item label="地区" label-width="80px">
        <el-cascader v-model="location" :props="locations" clearable></el-cascader>
      </el-form-item>
      <el-form-item label="服务商" label-width="80px" v-if="$permission.hasAuth([4, 8, 14, 3])">
        <el-select v-model="queryParam.agentSn" clearable filterable remote :remote-method="getAgents" :loading="loading" placeholder="输入服务商名称搜索">
          <el-option v-for="agent in agents" :key="agent.sn" :label="agent.companyName" :value="agent.sn"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="运营老师" label-width="80px" v-if="$permission.hasAuth([4, 8, 14, 11])">
        <el-select v-model="queryParam.generalServiceSn" clearable>
          <el-option v-for="service in services" :key="service.sn" :label="service.name" :value="service.sn"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="注册时间" label-width="80px">
        <el-date-picker
            v-model="dateRange"
            type="daterange"
            value-format="YYYY-MM-DD"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="截止时间"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="下单时间" label-width="80px">
        <el-date-picker
            v-model="dateRange2"
            type="daterange"
            value-format="YYYY-MM-DD"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="截止时间"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label-width="0">
        <el-button type="primary" @click="list(1)">
          <el-icon><search /></el-icon>查询
        </el-button>
      </el-form-item>
    </el-form>
  </div>
  <div class="table-container">
    <div class="table-header">
      <el-row :gutter="10">
        <el-col :span="10">
          <div class="table-title"><span></span>门店列表</div>
        </el-col>
        <el-col :span="14">
          <div class="table-button-container">
            <!--
            <el-button type="primary" v-if="$permission.hasAuth([4, 8, 10, 11]) || currentUser.directAgent" @click="exportData()">
              导出服务商门店名录
            </el-button>
            <el-button type="primary" v-if="$permission.hasAuth([4, 8, 10, 11])" @click="exportAgentShops()">
              本月开发
            </el-button>
            <el-button type="primary" v-if="0 && $permission.hasAuth([4, 8, 10, 11])" @click="exportShops()">
              导出门店
            </el-button>
            <el-button type="primary" v-if="$permission.hasAuth([4, 8, 10, 11])" @click="showGroup()">
              设置QQ群
            </el-button>
            <el-button type="primary" v-if="$permission.hasAuth([4, 8, 11])" @click="showDistribute()">
              分配运营老师
            </el-button>
            <el-button type="success" v-if="$permission.hasAuth([4, 8])" @click="showShop()">
              <el-icon><plus /></el-icon>新增门店
            </el-button>
            -->
          </div>
        </el-col>
      </el-row>
    </div>
    <el-table :data="shops" @selection-change="handleSelectionChange" border>
      <!--
      <el-table-column v-if="$permission.hasAuth([4, 8, 10, 11])" type="selection"></el-table-column>
      <el-table-column v-if="$permission.hasAuth([4, 8, 10, 11])" label="运营老师（群）">
        <template #default="scope">
          {{scope.row.generalServiceName}}{{scope.row.qqQun ? '（' + scope.row.qqQun + '）' : ''}}
        </template>
      </el-table-column>
      -->
      <el-table-column label="注册时间">
        <template #default="scope">
          {{scope.row.createDate.substr(0, 10)}}
        </template>
      </el-table-column>
      <el-table-column label="门店名称">
        <template #default="scope">
          <div>
            <span class="type_tag type_0" v-if="scope.row.xueType === 0">保</span>
            <span class="type_tag type_1" v-else-if="scope.row.xueType === 1">修</span>
            {{scope.row.companyName}}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="姓名"></el-table-column>
      <el-table-column prop="phone" label="手机号"></el-table-column>
      <el-table-column prop="orders" label="单数" width="60"></el-table-column>
      <el-table-column prop="servicePhone" label="联系电话" v-if="0"></el-table-column>
      <el-table-column label="服务">
        <template #default="scope">
          <pre class="pre_class">{{scope.row.serviceContent}}</pre>
        </template>
      </el-table-column>
      <el-table-column label="门店地址">
        <template #default="scope">
          {{scope.row.provinceName + (scope.row.cityName === scope.row.provinceName ? '' : scope.row.cityName) + scope.row.countyName}}{{scope.row.address}}
        </template>
      </el-table-column>
      <el-table-column label="收货信息" width="220" v-if="0">
        <template #default="scope">
          <pre class="pre_class">{{scope.row.logisticsInfo}}</pre>
        </template>
      </el-table-column>
      <el-table-column label="到期时间" v-if="0">
        <template #default="scope">
          {{scope.row.factoryAuthEndTime ? scope.row.factoryAuthEndTime.substr(0, 10) : ''}}
        </template>
      </el-table-column>
      <el-table-column prop="agentCompanyName" label="服务商">
        <template #default="scope">
          {{scope.row.agentPhone}}<br/>{{scope.row.agentCompanyName}}
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template #default="scope">
          <el-link type="primary" href="javascript:;" v-if="$permission.hasAuth([4, 8])" @click="showShop(scope.row)">修改</el-link>
          <el-dropdown>
            <span class="cursor_pointer color_normal">
              操作<el-icon><arrow-down/></el-icon>
            </span>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item :disabled="!scope.row.expired" @click="renew(scope.row)">续费</el-dropdown-item>
                <el-dropdown-item v-if="$permission.hasAuth([4])" @click="showUpgrade(scope.row)">升级</el-dropdown-item>
                <el-dropdown-item v-if="$permission.hasAuth([4])" @click="exit(scope.row)">退盟</el-dropdown-item>
                <el-dropdown-item v-if="$permission.hasAuth([4, 8, 14, 3]) && !scope.row.openId" @click="showCode(scope.row)">绑定码</el-dropdown-item>
                <el-dropdown-item v-if="$permission.hasAuth([1, 5]) && scope.row.factoryAuthFeePayed && !scope.row.factoryFirstOrder" @click="goShopFirst(scope.row)">门店首单</el-dropdown-item>
                <el-dropdown-item v-if="$permission.hasAuth([4, 8, 14]) && scope.row.factoryAuthFeePayed && scope.row.factoryFirstOrder" @click="addShopFirst(scope.row)">增补门店首单</el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @current-change="handleCurrentChange" v-model:current-page="pageIndex" @size-change="handleSizeChange"
                   :page-size="pageSize" :total="total" :page-sizes="pageSizes" :pager-count="5"
                   background
                   layout="sizes, prev, pager, next, total"></el-pagination>
  </div>

  <el-dialog :title="shop.sn ? '修改门店' : '新增门店'" v-model="saveShopVisible" custom-class="dialog_width_large" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="shop" ref="shop">
      <el-row :gutter="8">
        <el-col :span="12">
          <el-form-item label="服务商" label-width="78px" v-if="$permission.hasAuth([4, 8, 3])">
            <el-select v-model="shop.agentSn" :disabled="!$permission.hasAuth([4])" filterable remote :remote-method="getAgents" :loading="loading" :placeholder="shop.agentCompanyName ? shop.agentCompanyName : '输入服务商名称搜索'">
              <el-option v-for="agent in agents" :key="agent.sn" :label="agent.companyName" :value="agent.sn"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="门店名称" label-width="78px">
            <el-input type="text" v-model="shop.companyName"></el-input>
          </el-form-item>
          <el-form-item label="姓名" label-width="78px">
            <el-input type="text" v-model="shop.name"></el-input>
          </el-form-item>
          <el-form-item label="手机号" label-width="78px">
            <el-input type="number" v-model="shop.phone"></el-input>
          </el-form-item>
          <el-form-item label="客服电话" label-width="78px">
            <el-input type="number" v-model="shop.servicePhone"></el-input>
          </el-form-item>
          <el-form-item label="门店地址" label-width="78px">
            <el-cascader ref="location" v-model="shopLocation" :props="shopLocations" @change="locationChangeHandler"></el-cascader>
            <el-input type="text" v-model="shop.address" @blur="getLbs" placeholder="**街道**号**座**室"></el-input>
          </el-form-item>
          <el-form-item label="收货人" label-width="78px" v-if="!shop.sn">
            <el-input type="text" v-model="shop.recName"></el-input>
          </el-form-item>
          <el-form-item label="收货电话" label-width="78px" v-if="!shop.sn">
            <el-input type="text" v-model="shop.recPhone"></el-input>
          </el-form-item>
          <el-form-item label="收货地址" label-width="78px" v-if="!shop.sn">
            <el-cascader ref="recLocation" v-model="recLocation" :props="recLocations" @change="recLocationChangeHandler"></el-cascader>
            <el-input type="text" v-model="shop.recAddress"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <div id="map_container" style="height: 320px;"></div>
        </el-col>
      </el-row>
      <el-button type="primary" @click="saveShop">确定</el-button>
    </el-form>
  </el-dialog>

  <el-dialog title="选择运营老师" v-model="serviceVisible" custom-class="dialog_width_small" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form>
      <el-form-item label="运营老师" label-width="78px">
        <el-select v-model="serviceSn" filterable placeholder="请选择运营老师">
          <el-option v-for="service in services" :key="service.sn" :label="service.name" :value="service.sn"></el-option>
        </el-select>
      </el-form-item>
      <el-button type="primary" @click="distribute">确定</el-button>
    </el-form>
  </el-dialog>

  <el-dialog title="设置QQ群" v-model="groupVisible" custom-class="dialog_width_small" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form>
      <el-form-item label="QQ群" label-width="78px">
        <el-select v-model="group" filterable allow-create>
          <el-option v-for="(item, index) in groups" :key="index" :label="item" :value="item"></el-option>
        </el-select>
      </el-form-item>
      <el-button type="primary" @click="saveGroup">确定</el-button>
    </el-form>
  </el-dialog>

  <el-dialog title="门店升级" v-model="upgradeVisible" custom-class="dialog_width_small" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form>
      <el-form-item label="认证店类型" label-width="98px">
        <el-radio-group v-model="shop.xueType">
          <el-radio :label="0">保养店</el-radio>
          <el-radio :label="1">维修店</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-button type="primary" @click="upgrade">确定</el-button>
    </el-form>
  </el-dialog>

  <el-dialog title="续费" v-model="payVisible" :close-on-click-modal="false" :close-on-press-escape="false" @close="stopTimer" width="300px">
    <div class="pay_container">
      <div class="code" ref="pay_code" id="pay_code"></div>
      <div class="tips">微信扫码支付</div>
      <div class="tips">{{payInfo.fee}}元/年</div>
    </div>
  </el-dialog>
</template>

<script>
import QRCode from 'qrcodejs2'
let tencentMap, markerLayer, cutDown

export default {
  name: "门店管理",
  props: {
    currentUser: {
      type: Object
    }
  },
  data() {
    return {
      pageSizes: [10, 20, 50],
      pageIndex: 1,
      pageSize: 10,
      locations: {},
      location: null,
      total: 0,
      queryParam: {},
      dateRange: null,
      dateRange2: null,
      shops: [],
      saveShopVisible: false,
      shop: {},
      shopLocations: [],
      shopLocation: null,
      recLocations: [],
      recLocation: null,
      agents: [],
      loading: false,
      services: [],
      serviceVisible: false,
      checkedShops: [],
      serviceSn: null,
      groupVisible: false,
      group: '',
      groups: [],
      upgradeVisible: false,
      payVisible: false,
      payInfo: {}
    }
  },
  methods: {
    list(pageIndex) {
      if (pageIndex) {
        this.pageIndex = pageIndex
      }
      if (this.location) {
        this.queryParam.provinceCode = this.location[0]
        this.queryParam.cityCode = this.location[1]
        this.queryParam.countyCode = this.location[2]
      }
      if (this.dateRange) {
        this.queryParam.startDate = this.dateRange[0]
        this.queryParam.endDate = this.dateRange[1]
      } else {
        this.queryParam.startDate = null
        this.queryParam.endDate = null
      }
      if (this.dateRange2) {
        this.queryParam.orderStartDate = this.dateRange2[0]
        this.queryParam.orderEndDate = this.dateRange2[1]
      } else {
        this.queryParam.orderStartDate = null
        this.queryParam.orderEndDate = null
      }
      this.$utils.deleteEmptyProperty(this.queryParam)
      this.$apis.shopMgr.list(this.pageIndex - 1, this.pageSize, this.queryParam).then(response => {
        let shops = response.data.data
        if (shops && shops.length > 0) {
          shops.forEach(item => {
            item.expired = item.factoryAuthEndTime == null || (new Date(item.factoryAuthEndTime) - new Date()) / (3600000 * 24) <= 30
          })
        }
        this.shops = shops
        this.total = response.data.total
      })
    },
    handleCurrentChange(pageIndex) {
      this.pageIndex = pageIndex
      this.list()
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize
      this.list(1)
    },
    handleSelectionChange(val) {
      this.checkedShops = val
    },
    showShop(shop) {
      if (tencentMap) {
        tencentMap.destroy()
        tencentMap = null
        markerLayer = null
      }
      this.saveShopVisible = true
      if (shop) {
        Object.assign(this.shop, shop)
        this.agents.push({
          sn: this.shop.agentSn,
          companyName: this.shop.agentCompanyName
        })
        this.shopLocation = [shop.provinceCode, shop.cityCode, shop.countyCode]
      } else {
        this.shopLocation = null
        this.recLocation = null
        this.shop = {
          agentSn: this.currentUser.type === 1 ? this.currentUser.sn : null,
          lat: 39.908552,
          lng: 116.397481
        }
      }
      setTimeout(() => {
        this.initMap()
      }, 100)
    },
    saveShop() {
      if (!this.shop.agentSn) {
        this.$message.error('请选择服务商')
        return
      }
      if (!this.shop.companyName) {
        this.$message.error('请输入门店名称')
        return
      }
      if (!this.shop.name) {
        this.$message.error('请输入姓名')
        return
      }
      if (!this.shop.phone) {
        this.$message.error('请输入手机号')
        return
      }
      if (!this.shop.servicePhone) {
        this.$message.error('请输入客服电话')
        return
      }
      if (!this.shopLocation || !this.shop.address) {
        this.$message.error('请输入地址')
        return
      }
      if (!this.shop.sn) {
        if (!this.shop.recName) {
          this.$message.error('请输入收货人')
          return
        }
        if (!this.shop.recPhone) {
          this.$message.error('请输入收货电话')
          return
        }
        if (!this.recLocation || !this.shop.recAddress) {
          this.$message.error('请输入收货地址')
          return
        }
      }
      if (!this.shop.sn) {
        this.$apis.shopMgr.add(this.shop).then(response => {
          if (response.status === 200) {
            this.$message({
              message: '新增成功',
              type: 'success'
            })
            this.saveShopVisible = false
            this.list()
          }
        })
      } else {
        this.$apis.shopMgr.edit(this.shop).then(response => {
          if (response.status === 200) {
            this.$message({
              message: '修改成功',
              type: 'success'
            })
            this.saveShopVisible = false
            this.list()
          }
        })
      }
    },
    exit(shop) {
      this.$confirm('确认门店【' + shop.companyName + '】解约？操作不可逆，请谨慎处理！', '退盟确认',
          {
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning'
          }
      ).then(() => {
        this.$apis.shopMgr.exit(shop.sn).then(response => {
          if (response.status === 200) {
            this.$message({
              message: '操作成功',
              type: 'success'
            })
            this.list()
          }
        })
      }).catch(() => {

      })
    },
    showDistribute() {
      if (!this.checkedShops || this.checkedShops.length <= 0) {
        this.$message.error('请选择门店')
        return
      }
      this.serviceVisible = true
      this.serviceSn = null
    },
    distribute() {
      if (!this.serviceSn) {
        this.$message.error('请选择运营老师')
        return
      }
      let param = {
        serviceSn: this.serviceSn,
        factorySns: this.checkedShops.map(item => item.sn)
      }
      this.$apis.shopMgr.distributeService(param).then(response => {
        if (response.status === 200) {
          this.$message({
            message: '分配成功',
            type: 'success'
          })
          this.serviceVisible = false
          this.list()
        }
      })
    },
    showGroup() {
      if (!this.checkedShops || this.checkedShops.length <= 0) {
        this.$message.error('请选择门店')
        return
      }
      this.groupVisible = true
      this.getGroups()
    },
    saveGroup() {
      if (!this.group) {
        this.$message.error('群不能为空')
        return
      }
      let param = {
        qqName: this.group,
        factorySns: this.checkedShops.map(item => item.sn).join()
      }
      this.$apis.shopMgr.saveGroup(param).then(response => {
        if (response.status === 200) {
          this.$message({
            message: '设置成功',
            type: 'success'
          })
          this.groupVisible = false
          this.list()
        }
      })
    },
    showUpgrade(shop) {
      this.shop = {
        sn: shop.sn,
        xueType: shop.xueType != null ? shop.xueType : 0
      }
      this.upgradeVisible = true
    },
    upgrade() {
      this.$apis.shopMgr.upgradeShop(this.shop).then(response => {
        if (response.status === 200) {
          this.$message({
            message: '升级成功',
            type: 'success'
          })
          this.upgradeVisible = false
          this.list()
        }
      })
    },
    exportAgentShops() {
      this.$apis.shopMgr.exportAgentShops().then(response => {
        if (response.status === 200) {
          setTimeout(() => {
            window.open(response.data)
          }, 1500)
        }
      })
    },
    exportShops() {
      if (this.location) {
        this.queryParam.provinceCode = this.location[0]
        this.queryParam.cityCode = this.location[1]
        this.queryParam.countyCode = this.location[2]
      }
      if (this.dateRange) {
        this.queryParam.startDate = this.dateRange[0]
        this.queryParam.endDate = this.dateRange[1]
      } else {
        this.queryParam.startDate = null
        this.queryParam.endDate = null
      }
      if (this.dateRange2) {
        this.queryParam.orderStartDate = this.dateRange2[0]
        this.queryParam.orderEndDate = this.dateRange2[1]
      } else {
        this.queryParam.orderStartDate = null
        this.queryParam.orderEndDate = null
      }
      this.$utils.deleteEmptyProperty(this.queryParam)
      this.$apis.shopMgr.exportShops(this.queryParam).then(response => {
        if (response.status === 200) {
          setTimeout(() => {
            window.open(response.data)
          }, 1500)
        }
      })
    },
    exportData() {
      this.$apis.shopMgr.exportData().then(response => {
        if (response.status === 200) {
          setTimeout(() => {
            window.open(response.data)
          }, 1500)
        }
      })
    },
    showCode(shop) {
      this.$alert(
          '<div style="text-align: center;">' +
          '<img src="' + this.$utils.imageSrc(shop.mipImage) + '" style="margin: 0 auto;display: block;width: 200px;"/>' +
          '<div style="font-size: 16px;color: gray;">微信扫一扫</div>' +
          '<div style="margin-top: 3px;font-size: 14px;color: gray;">（' + shop.companyName + '）</div>' +
          '</div>',
          '绑定码', {dangerouslyUseHTMLString: true, showConfirmButton: false})
    },
    getAgents(str) {
      if (str !== '') {
        this.loading = true
        this.$apis.agentMgr.list(0, 15, {companyName: str}).then(response => {
          this.agents = response.data.data
          this.loading = false
        })
      } else {
        this.agents = []
      }
    },
    goShopFirst(shop) {
      let routeUrl = this.$router.resolve({
        path: '/index/store/shopFirst',
        query: {
          sn: shop.sn
        }
      })
      window.open(routeUrl.href, '_blank')
    },
    addShopFirst(shop) {
      this.$confirm('确认增补门店【' + shop.companyName + '】首单？', '首单确认',
          {
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning'
          }
      ).then(() => {
        this.$apis.store.addShopFirst(shop.sn).then(response => {
          if (response.status === 200) {
            this.$message({
              message: '操作成功',
              type: 'success'
            })
            this.list()
          }
        })
      }).catch(() => {

      })
    },
    getGroups() {
      this.$apis.shopMgr.getGroups().then(response => {
        this.groups = response.data
      })
    },
    renew(shop) {
      this.$apis.shopMgr.pay(shop.sn).then(response => {
        this.payInfo = response.data
        this.payVisible = true
        setTimeout(() => {
          document.getElementById('pay_code').innerHTML = ''
          new QRCode(this.$refs.pay_code, {
            text: this.payInfo.qrcode,
            width: 200,
            height: 200,
            colorDark: '#000000',
            colorLight: '#ffffff',
            correctLevel: QRCode.CorrectLevel.H
          })
        }, 200)
        cutDown = setInterval(() => {
          this.$apis.shopMgr.payResult(this.payInfo.outTradeNo).then(response => {
            if (response.status === 200) {
              this.stopTimer()
              this.$message({
                message: '续费成功',
                type: 'success'
              })
              this.payVisible = false
              this.list()
            }
          })
        }, 1500)
      })
    },
    stopTimer() {
      clearInterval(cutDown)
    },
    locationChangeHandler() {
      const node = this.$refs['location'].getCheckedNodes()
      this.shop.provinceCode = node[0].pathValues[0]
      this.shop.provinceName = node[0].pathLabels[0]
      this.shop.cityCode = node[0].pathValues[1]
      this.shop.cityName = node[0].pathLabels[1]
      this.shop.countyCode = node[0].pathValues[2]
      this.shop.countyName = node[0].pathLabels[2]
    },
    recLocationChangeHandler() {
      const node = this.$refs['recLocation'].getCheckedNodes()
      this.shop.recProvinceCode = node[0].pathValues[0]
      this.shop.recProvinceName = node[0].pathLabels[0]
      this.shop.recCityCode = node[0].pathValues[1]
      this.shop.recCityName = node[0].pathLabels[1]
      this.shop.recCountyCode = node[0].pathValues[2]
      this.shop.recCountyName = node[0].pathLabels[2]
    },
    locationLazyLoad(node, resolve) {
      let _that = this
      if (node.level === 0) {
        _that.$apis.common.provinces().then(response => {
          const provinces = response.data
          let nodes = []
          provinces.forEach(item => {
            nodes.push({
              value: item.code,
              label: item.name,
              leaf: false
            })
          })
          resolve(nodes)
        })
      } else if (node.level === 1) {
        _that.$apis.common.cities(node.value).then(response => {
          const cities = response.data
          let nodes = []
          cities.forEach(item => {
            nodes.push({
              value: item.code,
              label: item.name,
              leaf: false
            })
          })
          resolve(nodes)
        })
      } else {
        _that.$apis.common.counties(node.value).then(response => {
          const counties = response.data
          let nodes = []
          counties.forEach(item => {
            nodes.push({
              value: item.code,
              label: item.name,
              leaf: true
            })
          })
          resolve(nodes)
        })
      }
    },
    getLbs() {
      this.$apis.common.getLbs(this.shop.provinceName + (this.shop.cityName === this.shop.provinceName ? '' : this.shop.cityName) + this.shop.countyName + this.shop.address).then(response => {
        this.shop.lat = response.data[1]
        this.shop.lng = response.data[0]
        this.initMap()
      })
    },
    initMap() {
      console.log('初始化腾讯地图', tencentMap)
      let center = new TMap.LatLng(this.shop.lat, this.shop.lng)
      if (!tencentMap) {
        tencentMap = new TMap.Map('map_container', {
          zoom: 17, //设置地图缩放级别
          center: center //设置地图中心点坐标
        })
      } else {
        tencentMap.setCenter(center)
      }

      let markerGeo = {
        id: 'center',
        position: tencentMap.getCenter()
      }
      if (!markerLayer) {
        // 创建一个位于地图中心点的marker
        markerLayer = new TMap.MultiMarker({
          map: tencentMap,
          geometries: [
            markerGeo
          ]
        })
      } else {
        markerLayer.updateGeometries([markerGeo])
      }
      //监听地图平移
      let _that = this
      tencentMap.on("pan", () => {
        markerGeo.position = tencentMap.getCenter()
        markerLayer.updateGeometries([markerGeo])
        _that.shop.lat = markerGeo.position.lat
        _that.shop.lng = markerGeo.position.lng
      })
    }
  },
  created() {
    if (this.currentUser.type === 1) {
      this.queryParam.agentSn = this.currentUser.sn
    } else if (this.currentUser.type === 5) {
      this.queryParam.agentOpSn = this.currentUser.sn
    } else if (this.currentUser.type === 10) {
      this.queryParam.generalServiceSn = this.currentUser.sn
    }
    this.$apis.common.userList(0, 99, {type: 10}).then(response => {
      this.services = response.data.data
    })
    this.list()
    this.locations = {
      checkStrictly: true,
      lazy: true,
      lazyLoad: this.locationLazyLoad
    }
    this.shopLocations = {
      lazy: true,
      lazyLoad: this.locationLazyLoad
    }
    this.recLocations = {
      lazy: true,
      lazyLoad: this.locationLazyLoad
    }
  }
}
</script>

<style scoped>
.pay_container .code {
  margin: 0 auto 12px;
  width: 200px;
}
.pay_container .tips {
  text-align: center;
  font-size: 14px;
  color: #909399;
}
.type_tag {
  display: inline-block;
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  vertical-align: middle;
  border-radius: 11px;
  font-size: 14px;
}
.type_tag.type_0 {
  border: 1px solid #67C23A;
  color: #FFFFFF;
  background: #67C23A;
}
.type_tag.type_1 {
  border: 1px solid #E6A23C;
  color: #FFFFFF;
  background: #E6A23C;
}
</style>